import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./authentication/authSlice";
import blogSlice from "./blogs/blogSlice";
import userSlice from "./User/UserSlice";
export const store = configureStore({
  reducer: {
    authentication: authSlice.reducer,
    blog: blogSlice.reducer,
    user:userSlice.reducer
  },
});
